import "./leasemanagement.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";

const LeaseManagement = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleViewImage = () => {
    if (selectedImage) {
      const viewWindow = window.open('', '_blank');
      viewWindow.document.write(`
        <html>
          <head>
            <title>View ${selectedImage.alt}</title>
            <style>
              body { 
                margin: 0; 
                padding: 20px; 
                font-family: Arial, sans-serif;
                background: #f5f5f5;
              }
              img { 
                max-width: 100%; 
                height: auto; 
                display: block;
                margin: 0 auto;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                border-radius: 8px;
              }
              .header {
                text-align: center;
                margin-bottom: 20px;
                font-size: 24px;
                font-weight: bold;
                color: #333;
              }
              .container {
                max-width: 1200px;
                margin: 0 auto;
                padding: 20px;
              }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="header">${selectedImage.alt}</div>
              <img src="${selectedImage.src}" alt="${selectedImage.alt}" />
            </div>
          </body>
        </html>
      `);
      viewWindow.document.close();
    }
  };

  const handlePrint = () => {
    const imageToPrint = selectedImage || document.querySelector('.leaseImage');
    
    if (imageToPrint) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>Lease Document - ${imageToPrint.alt}</title>
            <style>
              body { 
                margin: 0; 
                padding: 20px; 
                font-family: Arial, sans-serif;
              }
              img { 
                max-width: 100%; 
                height: auto; 
                display: block;
                margin: 0 auto;
              }
              .header {
                text-align: center;
                margin-bottom: 20px;
                font-size: 18px;
                font-weight: bold;
              }
            </style>
          </head>
          <body>
            <div class="header">${imageToPrint.alt}</div>
            <img src="${imageToPrint.src}" alt="${imageToPrint.alt}" />
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  const handleSaveAsPDF = async () => {
    setIsProcessing(true);
    try {
      const { jsPDF } = await import('jspdf');
      const html2canvas = await import('html2canvas');
      
      const imageToCapture = selectedImage || document.querySelector('.leaseImage');
      
      if (imageToCapture) {
        const canvas = await html2canvas.default(imageToCapture, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        });
        const imgData = canvas.toDataURL('image/png');
        
        const pdf = new jsPDF();
        const imgWidth = 190; // A4 width in mm with margins
        const pageHeight = 277; // A4 height in mm with margins
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;

        let position = 10; // Start with top margin

        pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight + 10;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        const fileName = `lease-document-${Date.now()}.pdf`;
        pdf.save(fileName);
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleImageClick = (imageElement) => {
    console.log('Image clicked:', imageElement.alt); // Debug log
    console.log('Setting selected image to:', imageElement);
    setSelectedImage(imageElement);
    
    // Remove selected class from all containers
    document.querySelectorAll('.leaseImageContainer').forEach(container => {
      container.classList.remove('selected');
    });
    
    // Add selected class to the clicked container
    imageElement.closest('.leaseImageContainer').classList.add('selected');
  };

  const handleContainerClick = (imageElement) => {
    console.log('Container clicked for image:', imageElement.alt);
    handleImageClick(imageElement);
  };

  console.log('Current selectedImage state:', selectedImage); // Debug log

  return (
    <div className="leaseManagement">
      <Sidebar />
      <div className="leaseManagementContainer">
        <Navbar />
        <div className="leaseContent">
          {selectedImage && (
            <div className="actionPrompt">
              <div className="promptContent">
                <h3>Document Selected: {selectedImage.alt}</h3>
                <p>What would you like to do with this document?</p>
                <div className="promptButtons">
                  <button 
                    onClick={handleViewImage} 
                    className="promptBtn viewBtn"
                    disabled={isProcessing}
                  >
                    <i className="fas fa-search"></i>
                    View Image
                  </button>
                  <button 
                    onClick={handlePrint} 
                    className="promptBtn printBtn"
                    disabled={isProcessing}
                  >
                    <i className="fas fa-print"></i>
                    Print Document
                  </button>
                  <button 
                    onClick={handleSaveAsPDF} 
                    className="promptBtn pdfBtn"
                    disabled={isProcessing}
                  >
                    <i className="fas fa-download"></i>
                    Save as PDF
                  </button>
                  <button 
                    onClick={() => {
                      console.log('Cancel clicked');
                      setSelectedImage(null);
                    }} 
                    className="promptBtn cancelBtn"
                    disabled={isProcessing}
                  >
                    <i className="fas fa-times"></i>
                    Cancel
                  </button>
                </div>
                {isProcessing && (
                  <div className="processingMessage">
                    <i className="fas fa-spinner fa-spin"></i>
                    Processing...
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="leasePlaceholders">
            <div 
              className="leaseImageContainer"
              onClick={() => {
                const img = document.querySelector('.leaseImageContainer:first-child .leaseImage');
                handleContainerClick(img);
              }}
            >
              <img
                src="/lease1.png"
                alt="Lease Document 1"
                className="leaseImage"
                onClick={(e) => {
                  e.stopPropagation();
                  handleImageClick(e.target);
                }}
              />
              <div className="imageOverlay">
                <span><i className="fas fa-hand-pointer"></i> Click to select document</span>
              </div>
              <div className="imageCaption">
                <i className="fas fa-file-contract"></i> Tenant Contract
              </div>
            </div>
            <div 
              className="leaseImageContainer"
              onClick={() => {
                const img = document.querySelector('.leaseImageContainer:nth-child(2) .leaseImage');
                handleContainerClick(img);
              }}
            >
              <img
                src="/lease2.webp"
                alt="Lease Document 2"
                className="leaseImage"
                onClick={(e) => {
                  e.stopPropagation();
                  handleImageClick(e.target);
                }}
              />
              <div className="imageOverlay">
                <span><i className="fas fa-hand-pointer"></i> Click to select document</span>
              </div>
              <div className="imageCaption">
                <i className="fas fa-file-signature"></i> Lease Contract
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaseManagement;
